import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

export const useLocationChange = (callback: () => void) => {
  const location = useLocation();
  const [originalLocation, setOriginalLocation] = useState(location.pathname);

  useEffect(() => {
    if (originalLocation !== location.pathname) {
      callback();
      setOriginalLocation(location.pathname);
    }
  }, [location.pathname]);
};
